import { AttachFileOutlined, WarningAmberOutlined } from "@mui/icons-material";
import { Box, Chip } from "@mui/material";
import { amber, blue, green, grey, orange, red } from "@mui/material/colors";
import { isEmpty, isNil } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FlxGrid from "../_src_shared/components/layout/FlxGrid";
import { formatLoanName } from "../_src_shared/utils/formatters/formatLoanName";
import { formatDate } from "../_src_shared/utils/functions/formatDate";
import { htmlStringToText } from "../_src_shared/utils/functions/htmlStringToText";
import FilePreview from "../components/common/FilePreview";
import TextareaInput from "../components/inputs/TextareaInput";
import Flx from "../components/layout/Flx";
import SideCardModal from "../components/modals/SideCardModal";
import FileUploadProcess from "../components/processes/FileUploadProcess";
import CommentsRenderer from "../components/renderers/CommentsRenderer";
import Txt from "../components/typography/Txt";
import InfoRowItem from "../components/ui/data/InfoRowItem";
import { useBorrowerPortalHook } from "../hooks/useBorrowerPortalHook";
import { useEndpointHook } from "../hooks/useEndpointHook";
import { profileSet } from "../redux/actions/profileActions";
import {
  financingRequestsClear,
  financingRequestsSet,
} from "../redux/reducers/financingRequestsReducer";
import {
  sidebarClose,
  sidebarSetBodySx,
} from "../redux/reducers/sidebarReducer";
import { useFileDocGroupAndTypesHook } from "../_src_shared/hooks/useFileDocGroupAndTypesHook";
import { getDaysAgo } from "../_src_shared/utils/functions/getDaysAgo";
import InfoItemLabel from "../components/ui/data/InfoItemLabel";

const UpdateLoanConditionForm = ({ data, metadata }) => {
  const { loading, updateBorrowerProfile } = useBorrowerPortalHook();
  const dispatch = useDispatch();
  const financingRequests = useSelector((state) => state?.financingRequests);
  const profile = useSelector((state) => state.profile);
  const onSubmit = (changedValues, { form, values, changes }) => {
    // const payload = [{ _id: file._id || file?.oid, ...changedValues }];
    // updateProfileDocuments({
    //   files: payload,
    //   onSuccessFn: () => {
    //     dispatch(sidebarClose());
    //   },
    // });

    // console.log("changedValues", changedValues);
    // return;
    updateBorrowerProfile({
      data: changedValues,
      onSuccessFn: (d) => {
        // console.log("Profile updated successfully", d);
        dispatch(profileSet(d)); // Use the current form values, not EX_USER_DATA_UPDATED
        // dispatch(profileSet(EX_USER_DATA_UPDATED)); // Use the current form values, not EX_USER_DATA_UPDATED
        dispatch(sidebarClose());
      },
    });
  };

  const associatedLoanId = metadata?.loanId;
  const { formatDocTypeLabel } = useFileDocGroupAndTypesHook({});

  const associatedLoanData = financingRequests?.find(
    (fr) => fr._id === associatedLoanId,
  );
  console.log({ associatedLoanData, associatedLoanId });

  // console.log("condition", data);
  useEffect(() => {
    dispatch(sidebarSetBodySx({ padding: "0 !important" }));
  }, []);
  return (
    <Flx
      column
      sx={{
        flexGrow: 1,
        height: "100%",
        overflow: "hidden",
        background: "#fafaf8",
      }}
    >
      <Flx
        sx={{ overflow: "auto", flexGrow: 1, height: "100%", p: 2 }}
        column
        g={0.5}
      >
        <SectionBox>
          <Flx column g={2.5}>
            <FlxGrid gap={2} grow={1} width="160px" lastItemSpan={2}>
              <InfoRowItem
                column
                label={"Condition Status"}
                value={data?.status}
              />

              <InfoRowItem
                column
                label={"Created Date"}
                value={formatDate(data?.commentDateTime)}
              />
              <InfoRowItem
                column
                label={"Last Updated"}
                value={
                  getDaysAgo(data?.updateDateTime) === 0
                    ? "Today"
                    : `${getDaysAgo(data?.updateDateTime)} days ago`
                }
              />
              <InfoRowItem
                column
                label={"Condition Type"}
                value={data?.requirementType}
              />

              {data?.dueDate && (
                <InfoRowItem
                  column
                  label={"Due Date"}
                  value={formatDate(data?.dueDate)}
                />
              )}

              <InfoRowItem
                column
                label={"Associated Loan"}
                value={formatLoanName(associatedLoanData)}
              />
            </FlxGrid>
          </Flx>
        </SectionBox>

        <SectionBox sx={{ gap: 3 }}>
          {data?.docType ? (
            <>
              <Flx
                fw
                jb
                g={2}
                //
                ac
                // sx={{ alignItems: "flex-start" }}
              >
                <InfoRowItem
                  column
                  ellipsis={false}
                  label={"What's Needed"} //Condition Details
                  value={
                    <>Missing Document: {formatDocTypeLabel(data?.docType)}</>
                  }
                />
              </Flx>

              <InfoRowItem
                column
                ellipsis={false}
                label={"Details"} //Condition Details
                value={htmlStringToText(data?.htmlString)}
              />
            </>
          ) : (
            <InfoRowItem
              column
              ellipsis={false}
              label={"What's Needed"} //Condition Details
              value={htmlStringToText(data?.htmlString)}
            />
          )}

          {!isEmpty(data?.uploadedDocumentIds) && (
            <Flx fw g={3} wrap ac>
              <Flx
                column
                sx={{
                  flexShrink: 0,

                  alignItems: "flex-start",
                }}
              >
                <InfoItemLabel fontSize={"11px"}>Document Status</InfoItemLabel>
                <DocStipStatusChip docStipStatus={data?.docStipStatus} />
              </Flx>
              <InfoRowItem
                column
                fw={false}
                ellipsis={false}
                label={"Uploaded Documents"} //Condition Details
                value={
                  <DocumentIdsRenderer
                    documents={associatedLoanData?.loanDocuments}
                    documentIds={data?.uploadedDocumentIds}
                  />
                }
              />
            </Flx>
          )}

          <InfoRowItem
            column
            ellipsis={false}
            label={"Document Upload"} //Condition Details
            value={
              <UploadFileToLoanConditionProcess
                loanId={associatedLoanId}
                conditionComments={data?.comments || data?.conditionComments}
                conditionId={data?._id}
                docGroup={data?.docGroup}
                docType={data?.docType}
                disableCategoryAndTypeSelection
              />
            }
          />
        </SectionBox>
        <SectionBox sx={{ g: 2, display: "flex", flexDirection: "column" }}>
          <CommentsRenderer
            onlyComments
            comments={data?.comments || data?.conditionComments}
          />
          <LoanConditionCommentTextbox
            loanId={associatedLoanId}
            conditionComments={data?.comments || data?.conditionComments}
            conditionId={data?._id}
            docGroup={data?.docGroup}
            docType={data?.docType}
            // disableCategoryAndTypeSelection
          />
        </SectionBox>
      </Flx>
      {/* <JsonPreview values={data} /> */}
    </Flx>
  );
};

const FilePreviewSidecardModal = ({ file, onClose }) => {
  return (
    <SideCardModal
      title={file?.file_display_name || "File Preview"}
      show={!isNil(file)}
      onClose={onClose}
      suppressBodyPadding
    >
      <FilePreview
        fileObject={file}
        containerId={file?.containerName}
        sx={{ overflowY: "auto" }}
      />
    </SideCardModal>
  );
};

const LoanConditionCommentTextbox = ({ loanId, conditionId }) => {
  const { loading, addCommentToUnderwritingRequirement } = useEndpointHook();

  const dispatch = useDispatch();

  const handleOnSubmit = (comm) => {
    addCommentToUnderwritingRequirement({
      dealId: loanId,
      requirementId: conditionId,
      commentText: comm,
      onSuccessFn: (updatedFinancingRequests) => {
        dispatch(financingRequestsSet(updatedFinancingRequests));
        dispatch(sidebarClose());
      },
    });
  };

  return (
    <CommentsRenderer
      onAddComment={handleOnSubmit}
      loading={loading}
      inputTypeBasic
      onlyInput
    />
  );
};

const SectionBox = ({ children, sx }) => {
  return (
    <Box
      sx={{
        // border: `1px solid ${grey[200]}`,
        border: "1px solid rgb(224, 221, 213)",
        p: 1.5,
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        // gap: 4,
        mb: 2,
        background: "#ffffff",
        // background: grey[50],
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

const DocStipStatusChip = ({ docStipStatus, fontSize = "11px" }) => {
  const config = {
    "Open Item": {
      color: blue[700],
      bg: blue[50],
      border: `1px solid ${blue[100]}`,
      icon: (
        <AttachFileOutlined
          sx={{ color: `${blue[700]} !important`, fontSize: "13px !important" }}
        />
      ),
    },
    "Received - Pending Review": {
      color: orange[700],
      bg: orange[50],
      border: `1px solid ${orange[100]}`,
    },
    "Reviewed - Not Accepted": {
      color: red[700],
      bg: red[50],
      border: `1px solid ${red[100]}`,
    },
    Accepted: {
      color: green[700],
      bg: green[50],
      border: `1px solid ${green[100]}`,
    },
  };

  const style = config[docStipStatus] || config["Open Item"];

  return (
    <Chip
      label={docStipStatus || "Open Item"}
      size="small"
      sx={{
        backgroundColor: style.bg,
        color: style.color,
        fontWeight: 600,
        border: style.border,
        fontSize: fontSize,
      }}
    />
  );
};

const UploadFileToLoanConditionProcess = ({
  loanId,
  conditionId,
  docType,
  docGroup,
  keyName,
}) => {
  const { loading, uploadFilesToUnderwritingRequirement } = useEndpointHook();

  const dispatch = useDispatch();

  const handleOnSubmit = (f) => {
    uploadFilesToUnderwritingRequirement({
      dealId: loanId,
      requirementId: conditionId,
      files: f,

      onSuccessFn: () => {
        dispatch(sidebarClose());
        dispatch(financingRequestsClear());
        // dispatch(profileClear());
      },
    });
  };
  return (
    <Flx column g={0.5}>
      {/* <Txt>Relevant Documents</Txt> */}
      <FileUploadProcess
        loanId={loanId}
        docType={docType}
        // background={"#ffffff"}
        borderSize={2}
        // disableCategoryAndTypeSelection
        disableCategoryAndTypeSelectionCount
        docGroup={docGroup}
        categoryAndTypeLabel={`Document Category`}
        keyName={keyName}
        onSubmit={handleOnSubmit}
        loading={loading}
      />
    </Flx>
  );
};

const DocumentIdsRenderer = ({ documents, documentIds }) => {
  const [file, setFile] = useState(null);
  const filteredFiles = documents?.filter((doc) =>
    documentIds?.includes(doc?._id),
  );

  const onPreviewFile = useCallback((file) => {
    setFile(file);
  }, []);
  return (
    <>
      <Flx wrap g={1}>
        {filteredFiles?.map((file) => (
          <FileChip key={file._id} file={file} onPreview={onPreviewFile} />
        ))}
      </Flx>
      <FilePreviewSidecardModal file={file} onClose={() => setFile(null)} />
    </>
  );
};

const FileChip = ({ file, label, onPreview }) => (
  <Chip
    icon={<AttachFileOutlined sx={{ fontSize: "14px !important" }} />}
    label={label || file?.file_display_name || file?.fileName || "File"}
    size="small"
    onClick={(e) => {
      e.stopPropagation();
      onPreview?.(file);
    }}
    sx={{
      height: 22,
      fontSize: 11,
      fontWeight: 500,
      bgcolor: blue[50],
      color: blue[700],
      borderRadius: "4px",
      cursor: "pointer",
      "& .MuiChip-icon": { color: blue[400] },
      "&:hover": { bgcolor: blue[100] },
    }}
  />
);

export default UpdateLoanConditionForm;
